module.exports = __webpack_public_path__ + "static/media/panel3.3bd9f29a.svg";